import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { D as DateService } from './index8.js';
import { d as defineCustomElement$1 } from './roche-icon2.js';

const rocheDateCss = ":host{display:block;margin-top:3rem;color:#999}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host roche-icon{display:inline-block;margin-right:0.3125rem;fill:#999}";
const RocheDateStyle0 = rocheDateCss;

const RocheDate = /*@__PURE__*/ proxyCustomElement(class RocheDate extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.date = undefined;
        this.format = 'MMMM DD, YYYY';
        this.showIcon = false;
        this.state = undefined;
    }
    async componentWillLoad() {
        this.state = {
            formatedDate: await DateService.formatDate(this.date, this.format),
        };
    }
    render() {
        return (h(Host, { key: '0a3d44021fbb8b4304a0b05310f67467dae528cc' }, this.showIcon && h("roche-icon", { icon: "mobile" }), h("time", { key: 'b924b351893d0dc37edeafe41f87d1aeb9c6e2ab', dateTime: DateService.getDateTimeValue(this.date) }, this.state.formatedDate)));
    }
    static get style() { return RocheDateStyle0; }
}, [1, "roche-date", {
        "date": [1],
        "format": [1],
        "showIcon": [4, "show-icon"],
        "state": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-date", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-date":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheDate);
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { RocheDate as R, defineCustomElement as d };

//# sourceMappingURL=roche-date2.js.map